import React from 'react'
import ToastService from 'react-material-toast'

const toast = ToastService.new({
    place: 'topRight',
    duration: 4,
    maxCount: 8
});

const AppToast = (message, success) => {

    if (!message) {
        return;
    }

    const view = (
        <div style={{width: '450px'}}>
            <div style={{width: '90%', wordBreak: 'normal'}}>
                {message}
            </div>
        </div>
    );
    switch (success) {
        case true:
        case "1":
        case 1:
            toast.success(view);
            break;
        case false:
        case "0":
        case 0:
            toast.error(view);
            break;
        default:
            toast.info(view);
            break;
    }
};

export default AppToast